var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('small',[_vm._v("Cliente Cédula:")]),_c('div',{staticClass:"flex"},[_c('vs-input',{staticClass:"w-full",attrs:{"disabled":"","placeholder":"Ingrese Cédula"},model:{value:(_vm.busqueda),callback:function ($$v) {_vm.busqueda=$$v},expression:"busqueda"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }